export const formatColumnName = (columnName) => {
  const columnMappings = {
    'userBarcode': 'User Barcode',
    'itemBarcode': 'Item Barcode',
    'object': 'Object',
    'action': 'Action',
    'date': 'Date',
    'servicePointId': 'Service Point',
    'source': 'Source',
    'description': 'Description',
    'id': 'ID',
    'linkToIds': 'Link To IDs',
    'items': 'Items'
  };

  return columnMappings[columnName] || columnName
    .split(/[_.]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatCellValue = (value, columnName) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const lowerColumnName = columnName.toLowerCase();

  if (lowerColumnName.includes('date') || lowerColumnName.includes('time')) {
    if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}/)) {
      try {
        return new Date(value);
      } catch (e) {
        return value;
      }
    }
  }

  if (typeof value === 'object' && Array.isArray(value)) {
    return value.map(item => item.itemBarcode || item).join(', ');
  }

  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return String(value);
    }
  }

  return value;
};

export const getColumnAlignment = (value, columnName) => {
  const lowerColumnName = columnName.toLowerCase();

  if (value instanceof Date || lowerColumnName.includes('date')) {
    return 'center';
  }

  if (lowerColumnName.includes('id') || lowerColumnName.includes('barcode')) {
    return 'center';
  }

  return 'left';
};

export const getNumberFormat = (value, columnName) => {
  if (value instanceof Date) {
    return 'dd/mm/yyyy hh:mm';
  }

  if (typeof value === 'number') {
    return '#,##0.##';
  }

  return null;
};